
import React from 'react';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import CustomBadge from './CustomBadge';

interface ServiceCardProps {
  icon?: React.ReactNode;
  title: string;
  badge?: string;
  description: string;
  className?: string;
  href?: string;
}

const ServiceCard: React.FC<ServiceCardProps> = ({
  icon,
  title,
  badge,
  description,
  className = '',
  href = '/contact',
}) => {
  return (
    <Card className={`overflow-hidden border border-astrem-gray-200 card-hover h-full ${className}`}>
      <CardHeader className="p-6">
        {badge && (
          <div className="mb-2">
            <CustomBadge variant="secondary">{badge}</CustomBadge>
          </div>
        )}
        {icon && <div className="text-astrem-black mb-4 text-3xl">{icon}</div>}
        <CardTitle className="text-xl md:text-2xl font-medium">{title}</CardTitle>
      </CardHeader>
      <CardContent className="p-6 pt-0">
        <CardDescription className="text-astrem-gray-600 text-base">
          {description}
        </CardDescription>
      </CardContent>
      <CardFooter className="p-6 pt-0 mt-auto">
        <Button 
          variant="ghost" 
          className="p-0 h-auto font-medium text-astrem-black hover:text-astrem-gray-600 hover:bg-transparent group"
          asChild
        >
          <a href={href}>
            Learn more
            <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
          </a>
        </Button>
      </CardFooter>
    </Card>
  );
};

export default ServiceCard;
